module.exports = __webpack_public_path__ + "228a0d174ba45859bf37b7f8167eae82.MP3";